import { Shirt, Feather, Leaf, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PILLARS = [
  { slug: "garment-care", label: "Expert Garment Care", icon: Shirt },
  { slug: "hand-finished", label: "Hand-Finished Pressing", icon: Feather },
  { slug: "eco-solvents", label: "Eco-Friendly Solvents", icon: Leaf },
  { slug: "doorstep", label: "Free Doorstep Pickup & Delivery", icon: Truck },
];

export default function TrustBar() {
  return (
    <div
      data-testid="trust-bar"
      className="relative border-b border-[#B08D2E]/10 bg-white/70 backdrop-blur-sm"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-8 px-5 py-10 sm:px-8 lg:grid-cols-4">
        {PILLARS.map((pillar, i) => {
          const Icon = pillar.icon;
          return (
            <Reveal key={pillar.slug} delay={0.08 * i}>
              <div
                data-testid={`trust-item-${pillar.slug}`}
                className="group flex items-center gap-4"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-[#B08D2E]/30 transition-[border-color,background-color,box-shadow] duration-500 group-hover:border-[#B08D2E]/70 group-hover:bg-[#B08D2E]/5 group-hover:shadow-[0_0_24px_rgba(176,141,46,0.18)]">
                  <Icon className="h-5 w-5 text-[#B08D2E]" strokeWidth={1.25} />
                </span>
                <span className="text-[11px] font-medium uppercase leading-[1.5] tracking-[0.2em] text-[#1A1A1A]/85 transition-colors duration-300 group-hover:text-[#8C6D1F]">
                  {pillar.label}
                </span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
}
